import { startVideoPage } from '@aperza/app-contents';
startVideoPage();
